const actions = {
  // Awaiting Approval List
  AWAITING_APPROVAL_LIST_BEGIN: "AWAITING_APPROVAL_LIST_BEGIN",
  AWAITING_APPROVAL_LIST_SUCCESS: "AWAITING_APPROVAL_LIST_SUCCESS",
  AWAITING_APPROVAL_LIST_ERR: "AWAITING_APPROVAL_LIST_ERR",
  AWAITING_APPROVAL_LIST_RESET: "AWAITING_APPROVAL_LIST_RESET",

  // Approved Unused List
  APPROVED_UNUSED_LIST_BEGIN: "APPROVED_UNUSED_LIST_BEGIN",
  APPROVED_UNUSED_LIST_SUCCESS: "APPROVED_UNUSED_LIST_SUCCESS",
  APPROVED_UNUSED_LIST_ERR: "APPROVED_UNUSED_LIST_ERR",
  APPROVED_UNUSED_LIST_RESET: "APPROVED_UNUSED_LIST_RESET",

  // Approved Used List
  APPROVED_USED_LIST_BEGIN: "APPROVED_USED_LIST_BEGIN",
  APPROVED_USED_LIST_SUCCESS: "APPROVED_USED_LIST_SUCCESS",
  APPROVED_USED_LIST_ERR: "APPROVED_USED_LIST_ERR",
  APPROVED_USED_LIST_RESET: "APPROVED_USED_LIST_RESET",

  // Approval Details
  APPROVAL_DETAILS_BEGIN: "APPROVAL_DETAILS_BEGIN",
  APPROVAL_DETAILS_SUCCESS: "APPROVAL_DETAILS_SUCCESS",
  APPROVAL_DETAILS_ERR: "APPROVAL_DETAILS_ERR",
  APPROVAL_DETAILS_RESET: "APPROVAL_DETAILS_RESET",

  // Update Approval Data
  UPDATE_APPROVAL_DATA_BEGIN: "UPDATE_APPROVAL_DATA_BEGIN",
  UPDATE_APPROVAL_DATA_SUCCESS: "UPDATE_APPROVAL_DATA_SUCCESS",
  UPDATE_APPROVAL_DATA_ERR: "UPDATE_APPROVAL_DATA_ERR",
  UPDATE_APPROVAL_DATA_RESET: "UPDATE_APPROVAL_DATA_RESET",

  // Check Discount
  CHECK_DISCOUNT_BEGIN: "CHECK_DISCOUNT_BEGIN",
  CHECK_DISCOUNT_SUCCESS: "CHECK_DISCOUNT_SUCCESS",
  CHECK_DISCOUNT_ERR: "CHECK_DISCOUNT_ERR",
  CHECK_DISCOUNT_RESET: "CHECK_DISCOUNT_RESET",

  // Check Exception Discount
  CHECK_EXCEPTION_DISCOUNT_BEGIN: "CHECK_EXCEPTION_DISCOUNT_BEGIN",
  CHECK_EXCEPTION_DISCOUNT_SUCCESS: "CHECK_EXCEPTION_DISCOUNT_SUCCESS",
  CHECK_EXCEPTION_DISCOUNT_ERR: "CHECK_EXCEPTION_DISCOUNT_ERR",
  CHECK_EXCEPTION_DISCOUNT_RESET: "CHECK_EXCEPTION_DISCOUNT_RESET",

  // Submit Exception Discount
  SUBMIT_EXCEPTION_DISCOUNT_BEGIN: "SUBMIT_EXCEPTION_DISCOUNT_BEGIN",
  SUBMIT_EXCEPTION_DISCOUNT_SUCCESS: "SUBMIT_EXCEPTION_DISCOUNT_SUCCESS",
  SUBMIT_EXCEPTION_DISCOUNT_ERR: "SUBMIT_EXCEPTION_DISCOUNT_ERR",
  SUBMIT_EXCEPTION_DISCOUNT_RESET: "SUBMIT_EXCEPTION_DISCOUNT_RESET",

  // Awaiting Approval
  getAwaitingApprovalListBegin: () => ({
    type: actions.AWAITING_APPROVAL_LIST_BEGIN,
  }),
  getAwaitingApprovalListSuccess: (data) => ({
    type: actions.AWAITING_APPROVAL_LIST_SUCCESS,
    data,
  }),
  getAwaitingApprovalListErr: (err) => ({
    type: actions.AWAITING_APPROVAL_LIST_ERR,
    err,
  }),
  getAwaitingApprovalListReset: () => ({
    type: actions.AWAITING_APPROVAL_LIST_RESET,
  }),

  // Approved Unused
  getApprovedUnusedListBegin: () => ({
    type: actions.APPROVED_UNUSED_LIST_BEGIN,
  }),
  getApprovedUnusedListSuccess: (data) => ({
    type: actions.APPROVED_UNUSED_LIST_SUCCESS,
    data,
  }),
  getApprovedUnusedListErr: (err) => ({
    type: actions.APPROVED_UNUSED_LIST_ERR,
    err,
  }),
  getApprovedUnusedListReset: () => ({
    type: actions.APPROVED_UNUSED_LIST_RESET,
  }),

  // Approved Used
  getApprovedUsedListBegin: () => ({
    type: actions.APPROVED_USED_LIST_BEGIN,
  }),
  getApprovedUsedListSuccess: (data) => ({
    type: actions.APPROVED_USED_LIST_SUCCESS,
    data,
  }),
  getApprovedUsedListErr: (err) => ({
    type: actions.APPROVED_USED_LIST_ERR,
    err,
  }),
  getApprovedUsedListReset: () => ({
    type: actions.APPROVED_USED_LIST_RESET,
  }),

  // Approval Details
  getApprovalDetailsBegin: () => ({
    type: actions.APPROVAL_DETAILS_BEGIN,
  }),
  getApprovalDetailsSuccess: (data) => ({
    type: actions.APPROVAL_DETAILS_SUCCESS,
    data,
  }),
  getApprovalDetailsErr: (err) => ({
    type: actions.APPROVAL_DETAILS_ERR,
    err,
  }),
  getApprovalDetailsReset: () => ({
    type: actions.APPROVAL_DETAILS_RESET,
  }),

  // Update Approval Data
  updateApprovalDataBegin: () => ({
    type: actions.UPDATE_APPROVAL_DATA_BEGIN,
  }),
  updateApprovalDataSuccess: (data) => ({
    type: actions.UPDATE_APPROVAL_DATA_SUCCESS,
    data,
  }),
  updateApprovalDataErr: (err) => ({
    type: actions.UPDATE_APPROVAL_DATA_ERR,
    err,
  }),
  updateApprovalDataReset: () => ({
    type: actions.UPDATE_APPROVAL_DATA_RESET,
  }),

  getCheckDiscountBegin: () => ({
    type: actions.CHECK_DISCOUNT_BEGIN,
  }),
  getCheckDiscountSuccess: (data) => ({
    type: actions.CHECK_DISCOUNT_SUCCESS,
    data,
  }),
  getCheckDiscountErr: (err) => ({
    type: actions.CHECK_DISCOUNT_ERR,
    err,
  }),
  getCheckDiscountReset: () => ({
    type: actions.CHECK_DISCOUNT_RESET,
  }),

  checkExceptionDiscountBegin: () => ({
    type: actions.CHECK_EXCEPTION_DISCOUNT_BEGIN,
  }),
  checkExceptionDiscountSuccess: (data) => ({
    type: actions.CHECK_EXCEPTION_DISCOUNT_SUCCESS,
    data,
  }),
  checkExceptionDiscountErr: (err) => ({
    type: actions.CHECK_EXCEPTION_DISCOUNT_ERR,
    err,
  }),
  checkExceptionDiscountReset: () => ({
    type: actions.CHECK_EXCEPTION_DISCOUNT_RESET,
  }),

  submitExceptionDiscountBegin: () => ({
    type: actions.SUBMIT_EXCEPTION_DISCOUNT_BEGIN,
  }),
  submitExceptionDiscountSuccess: (data) => ({
    type: actions.SUBMIT_EXCEPTION_DISCOUNT_SUCCESS,
    data,
  }),
  submitExceptionDiscountErr: (err) => ({
    type: actions.SUBMIT_EXCEPTION_DISCOUNT_ERR,
    err,
  }),
  submitExceptionDiscountReset: () => ({
    type: actions.SUBMIT_EXCEPTION_DISCOUNT_RESET,
  }),
};

export default actions;
